import React from "react";
//*import PropTypes from 'prop-types';
import "./meetingListSkeleton.scss";
import { URLineSkeleton } from "./skeletonWidgets/lineSkeleton";
export default function URmeetListSkeleton(props: any) {
  return (
    <>
      <div className="skeletonLoading">
        <div className="meetinglistSkeleton">
          <div className="detailsList">
              <div className="detailscenter temp">
                   <URLineSkeleton className='line line8 size65'/>
              </div>
               <div className="detailscenter modify">
                  <URLineSkeleton className='line lineThick size45 '/>
                  <URLineSkeleton className='line line3 size2 '/>
                  <URLineSkeleton className='line lineThick size30 '/>
              </div>
               <div className="detailscenter action">
                   <URLineSkeleton className='line line12 size45 '/>
                  <URLineSkeleton className='line line12 size30 '/>
              </div>
          </div>
        </div>
       
      </div>
    </>

  );
}

